import { ModelBase, Property, Required, ShortString } from '@skylab-shared/core';

export class ClientGroupModel extends ModelBase {
    @Property({ identifiable: true })
    public externalId: string;

    @Property()
    public isDefault: boolean;

    @Property()
    @ShortString('data-model.client-group.validation.name.length')
    @Required('data-model.client-group.validation.name.no-empty')
    public name: string;
}
